import { Col, Row, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {
  isResetPasswordTokenValid,
  resetPasswordWithEmailToken,
} from '../../api/constlink';
import ResetPasswordComponent from '../../components/auth/ResetPasswordComponent';
import Title from 'antd/lib/typography/Title';

const { Text } = Typography;

function ForgotPasswordVerificationContainer({
  history,
  match,
}: RouteComponentProps<{ newPasswordToken: string }>) {
  const { newPasswordToken } = match.params;
  const [isTokenValid, setIsTokenValid] = useState<boolean>(false);
  // const [error, setError] = useState<any>(null);
  // const handleClose = () => {
  //   setError(null);
  // };

  useEffect(() => {
    (async () => {
      if (newPasswordToken === undefined) {
        setIsTokenValid(false);
        return;
      }
      const res = await isResetPasswordTokenValid({
        newPasswordToken,
      });
      if (res.isOk) {
        setIsTokenValid(true);
      } else {
        setIsTokenValid(false);
      }
    })();
  }, [newPasswordToken]);

  const onFinish = async ({ newPassword }: any) => {
    const res = await resetPasswordWithEmailToken({
      data: { newPassword, newPasswordToken },
    });
    if (res.isOk) {
      alert('비밀번호가 변경 되었습니다.');
      history.push('/login');
    } else {
      alert('비밀번호 변경 실패하였습니다.');
    }
  };

  return (
    <>
      {/* {error ? (
        <Alert
          message={`${error.message}`}
          type="error"
          closable
          afterClose={handleClose}
        />
      ) : null} */}
      {isTokenValid ? (
        <ResetPasswordComponent onFinish={onFinish} />
      ) : (
        <>
          <Row justify={'center'} style={{ marginTop: '50px' }}>
            <Col span={18}>
              <img
                src={`${process.env.PUBLIC_URL}/img/higongsa_logo.png`}
                alt="higongsa_logo"
                style={{ width: '200px' }}
              />
            </Col>
          </Row>
          <Row justify={'center'} style={{ marginTop: '10px' }}>
            <Col span={18}>
              <Title level={4}>해당 링크는 유효하지 않습니다.</Title>
            </Col>
          </Row>
          <Row justify={'center'} style={{ marginTop: '10px' }}>
            <Col span={18}>
              <Text>해당링크는 만료시간이 지났습니다.</Text>
            </Col>
          </Row>
        </>
      )}
    </>
  );
}

export default ForgotPasswordVerificationContainer;
